module.exports = __webpack_public_path__ + "static/media/fatura.6b14782c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fatura.svg
// module id = 2750
// module chunks = 0